import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

// import styles
import './datechangepopup.scss'

class DateChangePopup extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.triggerOpen = this.triggerOpen.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount () {
    this._mounted = true
    if (typeof this.props.open !== 'undefined') {
      if (this.props.open) {
        this.triggerOpen()
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.open !== 'undefined') {
      if (this.props.open !== nextProps.open) {
        if (nextProps.open) {
          this.triggerOpen()
        }
      }
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleClick, false)
    this._mounted = false
  }

  triggerOpen (onlyClose) {
    if (!this.state.isOpen) {
      document.addEventListener('click', this.handleClick, false)
    } else {
      document.removeEventListener('click', this.handleClick, false)
    }
    if (onlyClose && typeof onlyClose === 'boolean') {
      document.removeEventListener('click', this.handleClick, false)
      this.setState({
        isOpen: false
      })
    } else {
      this.setState({
        isOpen: !this.state.isOpen
      })
    }
  }

  close () {
    document.removeEventListener('click', this.handleClick, false)
    this.setState({
      isOpen: false
    })
  }

  handleClick (e) {
    let allowExtraClasses = ['rdtSwitch', 'rdtMonth', 'rdtYear', 'rdtYear rdtOld']
    let component = ReactDOM.findDOMNode(this.refs.component)

    // Target and parent classes
    const targetClasses = [ ...e.target.className.split(' '), ...e.target.parentNode.className.split(' ') ]
    const isFromDropdown = !![ 'element-dropdown__option', 'drop__option' ].find(c => targetClasses.includes(c))

    // console.log('handleClick', e.target === component, component.contains(e.target), allowExtraClasses.indexOf(e.target.className) !== -1, isFromDropdown, e.target, e.target.parentNode)
    if (e.target === component || component.contains(e.target) || allowExtraClasses.indexOf(e.target.className) !== -1 || isFromDropdown) {
      if (e.target.tagName.toLowerCase() === 'a') {
        this.props.handleClick(e.target)
        if (e.target.dataset.action !== 'delete') {
          if (this._mounted) {
            this.triggerOpen()
          }
        }
      }
    } else {
      if (this._mounted) {
        this.triggerOpen()
      }
    }
  }

  render () {
    let actionMenu = ''
    if (this.state.isOpen) {
      actionMenu = this.props.renderActionMenu(this.triggerOpen)
    }

    let onClick = () => {
      if (this.props.selfClick && !this.state.isOpen) this.triggerOpen()
    }

    return (
      <div className={this.props.className()} ref='component' onClick={onClick}>
        {this.props.renderActionOpener(this.triggerOpen)}
        {actionMenu}
      </div>
    )
  }

}

DateChangePopup.propTypes = {
  renderActionMenu: PropTypes.func.isRequired,
  renderActionOpener: PropTypes.func.isRequired
}

DateChangePopup.defaultProps = {
  className: () => {
    return 'datechangepopup'
  },
  renderActionOpener: (triggerOpen) => {
    return (
      <span onClick={triggerOpen}>
        <img src='/images/icons/menu_dots16.png' />
      </span>
    )
  },
  renderActionMenu: () => {
    return (
      <div className='poppedup'>
        POPUP
      </div>
    )
  }
}

export default DateChangePopup



// WEBPACK FOOTER //
// ./src/app/shared/components/DateChangePopup/index.js